import { faceUpdated } from './faceUpdated';
import type { ActionsOfCreators, FeatureHandler } from '../helpers';

export const outputActions = [faceUpdated];

export type OutputActions = ActionsOfCreators<typeof outputActions>;

export type Handler<T extends OutputActions> = FeatureHandler<T, OutputActions>;
